import React from "react";

import Scenarios from "components/Monitoring/Scenarios";
import { NumberLabel } from "aible";
import numeral from "numeral";

export const NUMERICLABEL_PARAMS = {
  shortFormat: true,
  shortFormatMinValue: 0,
  shortFormatPrecision: 1,
  precision: 1,
  justification: "L",
  locales: "en-US"
};

import {
  GRAPH_MODES,
  TARGET_VALUE_MODES,
  GRAPH_MODES_HIDE_CUMULATIVE,
  GRAPH_MODES_HIDE_ASSUMED
} from "containers/Monitoring/reducer";

import styles from "./style.module.css";

import { getRange, getPrettyNumber } from "aible";

import { AutoSizer } from "react-virtualized";

import { LineChart, ResponsiveContainer, ReferenceLine, Line, XAxis, YAxis, Tooltip } from "recharts";

import Select from "react-select";

const GRAPH_INFO = {
  CURRENT: "CURRENT",
  WORST: "WORST",
  BEST: "BEST"
};

const CLASS_MAPPING = {
  [GRAPH_INFO.CURRENT]: "current",
  [GRAPH_INFO.WORST]: "red",
  [GRAPH_INFO.BEST]: "green"
};

const CustomToolTip = (props) => {
  const { active, payload, isDeviation } = props;
  if (!active || !payload) {
    return null;
  }

  const date = payload[0] && payload[0].payload && payload[0].payload.date;

  payload.sort((a, b) => (b.name > a.name ? 1 : -1));

  return (
    <div className={styles.toolTipWrapper}>
      <div className={styles.toolTopBody}>
        <strong>{"Date: "}</strong>
        {date}
      </div>
      <div style={{ padding: "4px" }} />
      {payload.map((data, i) => {
        if (!data.payload || data.value === undefined) {
          return <div key={"maingraph" + i} />;
        }
        let name = data.payload[data.dataKey.charAt(0) + "Name"];
        if (data.dataKey.charAt(0) === "s") {
          name = "Actual";
        }
        if (data.dataKey.length >= 11 && data.dataKey.substr(data.dataKey.length - 7) === "Assumed") {
          name = "Projected";
        }
        if (isDeviation) {
          name = "Mean Absolute Error";
        }
        return (
          <div key={"maingraph" + i} className={styles.toolTopBody} style={{ color: data.color }}>
            <strong>{name + ": "}</strong>
            {numeral(data.value).format("0,0" + (data.value > 1000 ? "" : ".[00]"))}
          </div>
        );
      })}
    </div>
  );
};

export default class MainGraph extends React.Component {
  state = {
    showAllScenarios: false,
    mainGraphMode: "Cumulative"
  };

  updateShowAllScenarios(value) {
    const { showAllScenarios } = this.state;

    const retValue = value !== undefined ? value : !showAllScenarios;
    return this.setState({ showAllScenarios: retValue });
  }

  render() {
    const {
      label,
      scenarios,
      latestScenarios,
      scenarioIndex,
      isContinuous,
      setupLabels,
      targetValue,
      targetValueOptions,
      updateTargetValue,
      graphMode,
      graphModeOptions,
      updateGraphMode
    } = this.props;
    const { showAllScenarios, mainGraphMode } = this.state;
    if (!scenarios || !latestScenarios) {
      return <div />;
    }
    const currentScenario =
      scenarioIndex !== undefined
        ? latestScenarios.scenarios.find((elem) => elem.index === scenarioIndex)
        : latestScenarios.selectedScenario;
    let worstScenario = latestScenarios && latestScenarios.worstScenario;
    let bestScenario = latestScenarios && latestScenarios.bestScenario;
    if (bestScenario && currentScenario && bestScenario.index === currentScenario.index) {
      bestScenario = undefined;
    }
    if (bestScenario && currentScenario && worstScenario.index === currentScenario.index) {
      worstScenario = undefined;
    }

    let valueKey = targetValue;
    if (targetValue === TARGET_VALUE_MODES.TOTAL_SUM) {
      valueKey = "totalSum";
    } else if (targetValue === TARGET_VALUE_MODES.AVERAGE_SUM) {
      valueKey = "averageSum";
    }

    const cumulativeData = {
      selected: 0,
      best: 0,
      worst: 0,
      selectedAssumed: 0,
      bestAssumed: 0,
      worstAssumed: 0
    };

    const dates = {
      first: scenarios[0] && scenarios[0].date,
      last: scenarios[scenarios.length - 1] && scenarios[scenarios.length - 1].date
    };

    const lineGraphData = scenarios.map((elem, i) => {
      const retData = {
        date: elem.date
      };
      elem?.scenarios?.forEach((scen) => {
        if (targetValue === TARGET_VALUE_MODES.AVERAGE_DEVIATION) {
          retData.selected = scen.averageDeviation;
          retData.sName = "Mean Absolute Error";
        } else if (targetValue === TARGET_VALUE_MODES.TOTAL_SUM) {
          const currValue = scen.totalSum;
          const currAssumedValue = scen.totalSumAssumed;
          retData.selected = currValue;
          cumulativeData.selected += currValue;
          retData.selectedAssumed = currAssumedValue;
          cumulativeData.selectedAssumed += currAssumedValue;
          // Should I show cumulative?
          retData.selectedCumulative = cumulativeData.selected;
          retData.selectedCumulativeAssumed = cumulativeData.selectedAssumed;
          retData.sName = "Total Sum";
        } else if (targetValue === TARGET_VALUE_MODES.AVERAGE_SUM) {
          const currValue = scen.averageSum;
          const currAssumedValue = scen.averageSumAssumed;
          retData.selected = currValue;
          cumulativeData.selected += currValue;
          retData.selectedAssumed = currAssumedValue;
          cumulativeData.selectedAssumed += currAssumedValue;
          // Cumulative doesn't make sense for this?
          retData.selectedCumulative = cumulativeData.selected;
          retData.selectedCumulativeAssumed = cumulativeData.selectedAssumed;
          retData.sName = "Average Sum";
        } else if (currentScenario && scen.index === currentScenario.index) {
          retData.selected = scen[valueKey];
          cumulativeData.selected += scen[valueKey];
          retData.selectedAssumed = scen[valueKey + "Assumed"];
          cumulativeData.selectedAssumed += scen[valueKey + "Assumed"];
          retData.selectedCumulative = cumulativeData.selected;
          retData.selectedCumulativeAssumed = cumulativeData.selectedAssumed;
          retData.sName = scen.name;
        } else if (bestScenario && scen.index === bestScenario.index) {
          retData.best = scen[valueKey];
          cumulativeData.best += scen[valueKey];
          retData.bestAssumed = scen[valueKey + "Assumed"];
          cumulativeData.bestAssumed += scen[valueKey + "Assumed"];
          retData.bestCumulative = cumulativeData.best;
          retData.bestCumulativeAssumed = cumulativeData.bestAssumed;
          retData.bName = scen.name;
        } else if (worstScenario && scen.index === worstScenario.index) {
          retData.worst = scen[valueKey];
          cumulativeData.worst += scen[valueKey];
          retData.worstAssumed = scen[valueKey + "Assumed"];
          cumulativeData.worstAssumed += scen[valueKey + "Assumed"];
          retData.worstCumulative = cumulativeData.worst;
          retData.worstCumulativeAssumed = cumulativeData.worstAssumed;
          retData.wName = scen.name;
        }
      });
      return retData;
    });

    return (
      <div className={styles.mainGraphWrapper}>
        <div className={styles.mainGraphHeader}>
          <div className={styles.mainGraphTitle}>{label}</div>
          <div className={styles.mainGraphSelect} style={{ width: isContinuous ? 300 : undefined }}>
            <Select
              value={targetValueOptions.find((elem) => elem.value === targetValue)}
              onChange={(s) => updateTargetValue(s.value)}
              options={targetValueOptions}
              className={styles.outcomePicker}
            />
          </div>
          <div className={styles.mainGraphInfo}>
            {targetValue === TARGET_VALUE_MODES.AVERAGE_DEVIATION ? (
              <React.Fragment>
                <InfoItem
                  color={"#512F77"}
                  label={"Mean Absolute Error"}
                  subTitle={dates.last}
                  value={currentScenario.averageDeviation}
                  unitType={setupLabels.unitType}
                />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <InfoItem
                  color={"#F47C20"}
                  label={"Projected"}
                  subTitle={
                    graphMode === GRAPH_MODES.CUMULATIVE
                      ? `Cumulative from ${dates.first} to ${dates.last}`
                      : dates.last
                  }
                  value={
                    graphMode === GRAPH_MODES.CUMULATIVE
                      ? cumulativeData.selectedAssumed
                      : currentScenario && currentScenario[valueKey + "Assumed"]
                  }
                  unitType={setupLabels.unitType}
                />
                <InfoItem
                  color={"#512F77"}
                  label={"Actual"}
                  subTitle={
                    graphMode === GRAPH_MODES.CUMULATIVE
                      ? `Cumulative from ${dates.first} to ${dates.last}`
                      : dates.last
                  }
                  value={
                    graphMode === GRAPH_MODES.CUMULATIVE
                      ? cumulativeData.selected
                      : currentScenario && currentScenario[valueKey]
                  }
                  unitType={setupLabels.unitType}
                />
              </React.Fragment>
            )}
          </div>
        </div>
        <div className={styles.mainGraphBody}>
          {/* <Scenarios
            showAllScenarios={showAllScenarios}
            updateShowAllScenarios={() => this.updateShowAllScenarios()}
            scenarios={latestScenarios.scenarios}
            scenarioIndex={scenarioIndex}
            currentScenario={currentScenario}
            isContinuous={isContinuous}
            showOnlyDeployed
            setupLabels={setupLabels}
          /> */}
          <LineGraph
            data={lineGraphData}
            currentScenario={currentScenario}
            showAllScenarios={showAllScenarios}
            valueKey={valueKey}
            graphMode={graphMode}
            targetValue={targetValue}
            graphModeOptions={graphModeOptions}
            updateGraphMode={updateGraphMode}
          />
        </div>
      </div>
    );
  }
}

class InfoItem extends React.PureComponent {
  render() {
    const { color, label, subTitle, value, unitType } = this.props;

    const isNegative = value < 0 ? "-" : "";
    const retValue = Math.abs(value);

    const retUnitType = unitType !== undefined ? unitType : "$";

    return (
      <div className={styles.infoItemWrapper}>
        <div className={styles.infoItemBody} style={color ? { borderBottomColor: color } : undefined}>
          <div className={styles.infoItemLabel}>{label}</div>
          <div className={styles.infoItemValue}>{isNegative + retUnitType + numeral(retValue).format("0.0a")}</div>
        </div>
        {subTitle ? <div className={styles.infoItemSubtitle}>{subTitle}</div> : <React.Fragment />}
      </div>
    );
  }
}

class LineGraph extends React.PureComponent {
  render() {
    const {
      data,
      showAllScenarios,
      currentScenario,
      bestScenario,
      worstScenario,
      valueKey,
      targetValue,
      graphMode,
      graphModeOptions,
      updateGraphMode
    } = this.props;

    if (!data) {
      return <div />;
    }

    const assumedKey = graphMode === GRAPH_MODES.CUMULATIVE ? "selectedCumulativeAssumed" : "selectedAssumed";
    const actualKey = graphMode === GRAPH_MODES.CUMULATIVE ? "selectedCumulative" : "selected";

    const yDataMin = Math.min.apply(
      Math,
      data.flatMap((p) => [p[assumedKey], p[actualKey]])
    );
    const yDataMax = Math.max.apply(
      Math,
      data.flatMap((p) => [p[assumedKey], p[actualKey]])
    );
    const yDomain = yDataMin === yDataMax ? undefined : getRange(yDataMin, yDataMax, true);

    const hideSelect = GRAPH_MODES_HIDE_CUMULATIVE.includes(targetValue);
    const selectedOption = graphModeOptions.find((elem) => elem.value === graphMode);
    return (
      <div className={styles.lineGraphWrapper + " " + (showAllScenarios ? styles.shrink : "")}>
        <div className={styles.lineGraphTitle} style={{ minHeight: hideSelect ? 38 : undefined }}>
          {!hideSelect && (
            <div className={styles.lineGraphTitleSelect}>
              <Select
                value={selectedOption}
                onChange={(s) => updateGraphMode(s.value)}
                options={graphModeOptions}
                className={styles.outcomePicker}
              />
            </div>
          )}
          <div className={styles.lineGraphTitleText}>{(hideSelect ? `${selectedOption.label} ` : "") + "Progress"}</div>
        </div>
        <div className={styles.lineGraphBody}>
          <AutoSizer>
            {({ width, height }) => (
              <LineChart width={width} height={height} data={data} margin={{ top: 10, right: 0, left: 20, bottom: 0 }}>
                <Tooltip
                  content={<CustomToolTip isDeviation={targetValue === TARGET_VALUE_MODES.AVERAGE_DEVIATION} />}
                  itemStyle={{ fontSize: "14px" }}
                  contentStyle={{ fontSize: "14px" }}
                  wrapperStyle={{ background: "#FFFFFF" }}
                />
                <XAxis dataKey={"date"} />
                <Line dataKey={actualKey} stroke={"#512F77"} strokeWidth={3} dot={false} />
                {targetValue !== TARGET_VALUE_MODES.AVERAGE_DEVIATION && (
                  <Line dataKey={assumedKey} stroke={"#F47C20"} strokeWidth={3} dot={false} />
                )}
                {/* <Line
                dataKey={"best"}
                stroke={"#5BCF74"}
                strokeWidth={3}
                dot={false}
              />
              <Line
                dataKey={"worst"}
                stroke={"#C03E5A"}
                strokeWidth={3}
                dot={false}
              /> */}
                <ReferenceLine y={0} strokeDasharray="3 3" />
                <YAxis domain={yDomain} tickFormatter={(tick) => getPrettyNumber(tick)} />
              </LineChart>
            )}
          </AutoSizer>
        </div>
      </div>
    );
  }
}
